@if (time) {
  <img src="../../../../assets/icons/icon_clock.svg" width="16" height="16" alt="horloge" />
  <p class="font-300 my-0">{{ time }} de lecture</p>
}
